import { api } from '../../../../components/common';
import {
  CreateLeaseRequest,
  EndLeaseRequest,
  LeaseListResponse,
  LeaseSearchParams,
  LeaseTenantOption,
  LeaseUnitOption,
  LeaseWithDetails,
  UpdateLeaseRequest
} from '../types';

export const leasesApi = {
  getAll: (params: LeaseSearchParams = {}): Promise<LeaseListResponse> => {
    const queryParams = new URLSearchParams();

    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.sorts && params.sorts.length > 0) {
      queryParams.append('sorts', JSON.stringify(params.sorts));
    }
    if (params.fields && params.fields.length > 0) {
      queryParams.append('fields', JSON.stringify(params.fields));
    }

    return api.get(`/leases?${queryParams.toString()}`).then((res) => res.data);
  },

  getById: (id: number): Promise<LeaseWithDetails> =>
    api.get(`/leases/${id}`).then((res) => res.data),

  create: (lease: CreateLeaseRequest): Promise<LeaseWithDetails> =>
    api.post('/leases', lease).then((res) => res.data),

  update: (id: number, lease: UpdateLeaseRequest): Promise<LeaseWithDetails> =>
    api.put(`/leases/${id}`, lease).then((res) => res.data),

  end: (id: number, data: EndLeaseRequest = {}): Promise<LeaseWithDetails> =>
    api.post(`/leases/${id}/end`, data).then((res) => res.data),

  delete: (id: number): Promise<void> =>
    api.delete(`/leases/${id}`).then(() => {}),

  getUnitOptions: (includeLeaseId?: number): Promise<LeaseUnitOption[]> => {
    const query = includeLeaseId ? `?includeLeaseId=${includeLeaseId}` : '';
    return api.get(`/leases/options/units${query}`).then((res) => res.data);
  },

  getTenantOptions: (includeLeaseId?: number): Promise<LeaseTenantOption[]> => {
    const query = includeLeaseId ? `?includeLeaseId=${includeLeaseId}` : '';
    return api.get(`/leases/options/tenants${query}`).then((res) => res.data);
  }
};
